// extracted by mini-css-extract-plugin
export default {"container":"SavedPodcastsPage_container__56493","icon-title":"SavedPodcastsPage_icon-title__b0WUS"};